__turbopack_context__.v({
  "className": "cormorant_garamond_91d5bbb0-module__r-IVrW__className",
  "variable": "cormorant_garamond_91d5bbb0-module__r-IVrW__variable",
});
